const PROJECT_NOTIFICATION_ROUTE = '/setting/project-notifications'

export default [
  {
    _name: 'CSidebarNav',
    _children: [
      { _name: 'CSidebarNavItem', name: 'ダッシュボード', to: '/dashboard', icon: 'cil-speedometer' },
      { _name: 'CSidebarNavTitle', _children: ['人員・休暇'] },
      { _name: 'CSidebarNavItem', name: '稼働ヒートマップ', to: '/admin/insights/workforce', icon: 'cil-grid' },
      // 上限は人に紐づくので、稼働ヒートマップの隣に置く。
      // 「集計」へ置くと、給与計算のために事務が入力する月次集計と同じ束になる。
      // この行は MANAGEMENT_INSIGHT_VIEW を持つ人にだけ残る（accessPolicy.js）。
      { _name: 'CSidebarNavItem', name: '36協定の上限状況', to: '/admin/insights/overtime-limits', icon: 'cil-warning' },
      { _name: 'CSidebarNavItem', name: '有休取得プランナー', to: '/insights/paid-leave', icon: 'cil-calendar' },
      { _name: 'CSidebarNavTitle', _children: ['集計'] },
      { _name: 'CSidebarNavItem', name: '月次集計', to: '/admin/total/list', icon: 'cil-list-rich' },
      { _name: 'CSidebarNavItem', name: 'プロジェクト集計', to: '/admin/total/list_project', icon: 'cil-list-rich' },
      { _name: 'CSidebarNavTitle', _children: ['管理/発行'] },
      { _name: 'CSidebarNavItem', name: 'プロジェクト単価設定', to: '/admin/project-rate', icon: 'cil-money' },
      { _name: 'CSidebarNavItem', name: '売上管理/請求書発行', to: '/admin/sales/salesManagement', icon: 'cil-layers' },
      { _name: 'CSidebarNavTitle', _children: ['経営予測'] },
      { _name: 'CSidebarNavItem', name: 'プロジェクト収益予測', to: '/admin/insights/project-profit', icon: 'cil-chart-pie' },
      { _name: 'CSidebarNavItem', name: '入金・請求予測', to: '/admin/insights/cash-flow', icon: 'cil-money' },
      { _name: 'CSidebarNavTitle', _children: ['一覧'] },
      { _name: 'CSidebarNavItem', name: '勤務表一覧', to: '/admin/roster/list', icon: 'cil-list-rich' },
      { _name: 'CSidebarNavItem', name: '業務報告一覧', to: '/admin/monthlyreports/list', icon: 'cil-list-rich' },
      { _name: 'CSidebarNavItem', name: '通勤費精算一覧', to: '/admin/payoff/travelCostList', icon: 'cil-list-rich' },
      { _name: 'CSidebarNavItem', name: '経費精算一覧', to: '/admin/payoff/expenseList', icon: 'cil-list-rich' },
      { _name: 'CSidebarNavItem', name: '休暇申請一覧', to: '/admin/paidandsubstitute/list', icon: 'cil-list-rich' },
      { _name: 'CSidebarNavItem', name: '予定外時間外報告一覧', to: '/admin/overtime/list', icon: 'cil-list-rich' },
      { _name: 'CSidebarNavItem', name: '休日出勤報告一覧', to: '/admin/holidaywork/list', icon: 'cil-list-rich' },
      { _name: 'CSidebarNavTitle', _children: ['申請と承認'] },
      { _name: 'CSidebarNavItem', name: '承認待ち一覧', to: '/submission_approval/submission_management', icon: 'cil-check', badge: null },
      { _name: 'CSidebarNavItem', name: '承認申請一覧', to: '/submission_approval/report_list', icon: 'cil-chevron-double-up', badge: null },
      { _name: 'CSidebarNavTitle', _children: ['月次報告'] },
      { _name: 'CSidebarNavItem', name: '勤務表', to: '/report/roster', icon: 'cil-notes' },
      { _name: 'CSidebarNavItem', name: '業務報告', to: '/report/monthlyreport', icon: 'cil-notes' },
      { _name: 'CSidebarNavItem', name: '通勤費精算', to: '/payoff/travelCost', icon: 'cil-bus-alt' },
      { _name: 'CSidebarNavItem', name: '経費精算', to: '/payoff/expense', icon: 'cil-money' },
      { _name: 'CSidebarNavTitle', _children: ['随時報告'] },
      { _name: 'CSidebarNavItem', name: '休暇申請', to: '/paidandsubstitutes/list', icon: 'cil-notes' },
      { _name: 'CSidebarNavItem', name: '予定外時間外報告', to: '/overtimes/list', icon: 'cil-notes' },
      { _name: 'CSidebarNavItem', name: '休日出勤報告', to: '/holidayworks/list', icon: 'cil-notes' },
      { _name: 'CSidebarNavTitle', _children: ['基本情報管理'] },
      { _name: 'CSidebarNavItem', name: 'プロジェクト', to: '/project/list', icon: 'cil-layers' },
      { _name: 'CSidebarNavItem', name: 'クライアント', to: '/client/list', icon: 'cil-layers' },
      { _name: 'CSidebarNavItem', name: '部署', to: '/department/list', icon: 'cil-building' },
      { _name: 'CSidebarNavItem', name: 'ユーザ', to: '/users/list', icon: 'cil-people' },
      // 会社の決めごとは、台帳（プロジェクト・クライアント・部署・ユーザ）の
      // 途中ではなく末尾にまとめる。**足したり消したりするものと、
      // 一度決めるものは別。**
      { _name: 'CSidebarNavItem', name: '会社全体通知設定', to: PROJECT_NOTIFICATION_ROUTE, icon: 'cil-bell' },
      { _name: 'CSidebarNavItem', name: '自社設定', to: '/setting/info', icon: 'cil-settings' }
    ]
  }
]
